import { render, staticRenderFns } from "./ReportNewView.vue?vue&type=template&id=5a255220&scoped=true&"
import script from "./ReportNewView.vue?vue&type=script&lang=js&"
export * from "./ReportNewView.vue?vue&type=script&lang=js&"
import style0 from "./ReportNewView.vue?vue&type=style&index=0&id=5a255220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a255220",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VForm,VIcon,VRow,VSelect,VSpacer,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a255220')) {
      api.createRecord('5a255220', component.options)
    } else {
      api.reload('5a255220', component.options)
    }
    module.hot.accept("./ReportNewView.vue?vue&type=template&id=5a255220&scoped=true&", function () {
      api.rerender('5a255220', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/ReportNewView.vue"
export default component.exports